/* RESPONSIBLE TEAM: team-inbox-experience */
import JSONAPIAdapter from '../json-api';

export default JSONAPIAdapter.extend({});
